import React from 'react';
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

// Create rtl cache
const cacheRtl = createCache({
  key: 'muirtl',
  // @ts-ignore
  stylisPlugins: [rtlPlugin]
});
function RtlEmotionCacheProvider(_ref) {
  let {
    children,
    seed
  } = _ref;
  cacheRtl.key = seed;
  return /*#__PURE__*/React.createElement(CacheProvider, {
    value: cacheRtl
  }, children);
}
export default RtlEmotionCacheProvider;